'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = _interopDefault(require('react'));
var componentsOptionaltext = require('@keytrade/components-optionaltext');
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var LabelItem = styled.label.withConfig({
  displayName: "Labelstyles__LabelItem",
  componentId: "sc-11vhjde-0"
})(["display:", ";position:relative;z-index:1;color:", ";margin:", ";font-family:", ";font-size:", ";line-height:", ";", ""], function (props) {
  return props.display || 'block';
}, function (props) {
  return props.theme.dark ? colors.White : colors[props.color];
}, function (props) {
  return props.margin ? props.margin : props.noMarginBottom ? '0' : props.theme.type === 'secure' || props.theme.type === 'small' ? '0 0 .2rem' : '0 0 .4rem';
}, function (props) {
  return getFont(props.theme, props.weight);
}, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '1.6rem' : '1.8rem';
}, function (props) {
  return props.isOptional && "\n    flex: 1 0 auto;\n    max-width: calc(100% - 7.5rem);\n  ";
});
var LabelWrapper = styled.div.withConfig({
  displayName: "Labelstyles__LabelWrapper",
  componentId: "sc-11vhjde-1"
})(["display:flex;justify-content:space-between;align-items:flex-end;margin:", ";"], function (props) {
  return function (props) {
    return props.margin ? props.margin : props.theme.type === 'secure' || props.theme.type === 'small' ? '0 0 .2rem' : '0 0 .4rem';
  };
});
var Label = function Label(_ref) {
  var children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    htmlFor = _ref.htmlFor,
    showOptionalText = _ref.showOptionalText,
    isOptional = _ref.isOptional,
    language = _ref.language,
    noMarginBottom = _ref.noMarginBottom,
    weight = _ref.weight,
    margin = _ref.margin;
  return isOptional && showOptionalText ? /*#__PURE__*/React.createElement(LabelWrapper, {
    className: className,
    margin: margin
  }, /*#__PURE__*/React.createElement(LabelItem, {
    color: color,
    htmlFor: htmlFor,
    noMarginBottom: true,
    isOptional: true,
    weight: weight
  }, children), /*#__PURE__*/React.createElement(componentsOptionaltext.OptionalText, {
    language: language
  })) : /*#__PURE__*/React.createElement(LabelItem, {
    className: className,
    color: color,
    htmlFor: htmlFor,
    noMarginBottom: noMarginBottom,
    weight: weight,
    margin: margin
  }, children);
};
Label.defaultProps = {
  weight: 'semiBold',
  color: 'BlueDark',
  noMarginBottom: false,
  showOptionalText: true,
  language: 'en'
};
exports.Label = Label;